import { BaseKey, IResourceComponentsProps, useExport, useGetIdentity, useList, useMany, useNavigation } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Tag,
  Input,
  Divider,
  Button,
  useTable,
  Form,
  Row,
  Col,
  Popconfirm,
} from '@pankod/refine-antd'

import { ITestTrack, IGrade, ISubject, IProduct, IReportTheme } from 'interfaces'
import { CreateTestTrack } from './create'
import { EditTestTrack } from './edit'
import Permissions from 'permissions'
import { useEffect, useState } from 'react'
import { useUserContext } from 'context/user'
import productMetaData from 'metadata/products'

import { exportToExcel } from 'exportToExcel'
import { getAllTestTrackDetails, getCount } from 'gql/query'
import { updateVisibiltityStatus } from 'gql/mutations'

const { PlusOutlined } = Icons
type Permission = {
  granted?: boolean
}

const { ExportOutlined } = Icons

export const TestTracksList: React.FC<IResourceComponentsProps> = () => {
  const [exportButtonLoading, setExportButtonLoading] = useState<boolean>(false)
  const [hasPagination, setHasPagination] = useState<any>(true)
  const [testTrackCount, setTestTrackCount] = useState(0)

  const { push } = useNavigation()
  const {
    tableProps,
    searchFormProps,
    sorter,
    tableQueryResult,
    setFilters: setTestTrackFilters,
  } = useTable<ITestTrack>({
    resource: 'test_tracks',
    hasPagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],

    metaData: {
      fields: ['id', 'name', 'grade_ids', 'subject_ids', 'created_at', 'report_theme_ids', 'in_use'],
    },
    onSearch(data: any) {
      return [{ field: 'name', operator: 'contains', value: `%${data?.name}%` }]
    },
  })
  const { tableQueryResult: productQueryResult } = useTable<IProduct>({ resource: 'products', metaData: productMetaData })
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('test_tracks'))
      setCreatePermission(Permissions.can(userRole).createAny('test_tracks'))
      setEditPermission(Permissions.can(userRole).updateAny('test_tracks'))
      setDeletePermission(Permissions.can(userRole).deleteAny('test_tracks'))
    }
  }, [userRole])

  const findTestTrack = async () => {
    try {
      let userId = user?.id
      let isAdmin = userRole === 'admin'
      const resource = 'test track'

      const responseTestTrackCount: any = await getCount({ userId, isAdmin, resource })
      // const responseTestTrackCount: any = await getCount('test track')
      let test_track_count = responseTestTrackCount?.test_tracks_aggregate?.aggregate?.count
      if (test_track_count) {
        setTestTrackCount(test_track_count)
      }
    } catch (err) {
      console.log('error on finding test track :', err)
    }
  }

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) {
      push('/')
    } else {
      findTestTrack()
    }
  }, [readPermission])

  const gradeList = useList<IGrade>({
    resource: 'grades',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })
  const subjectLists = useList<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })
  const reportThemeLists = useList<IReportTheme>({
    resource: 'report_themes',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'test_tracks',
    action: 'create',
    onMutationSuccess: async () => {
      await findTestTrack()
    },
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'test_tracks',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'grade_ids', 'subject_ids', 'created_at', 'report_theme_ids'],
    },
  })
  const renderItems = (item: any, typeIs: string) => {
    let subject_text: string = ''
    if (item?.length) {
      for (let i = 0; i < item.length; i++) {
        const checkingList: any = typeIs === 'subject' ? subjectLists : typeIs === 'reportTheme' ? reportThemeLists : []
        let result = checkingList?.data?.data?.filter((subjects: any) => item[i] === subjects?.id)[0]
        if (result !== undefined) {
          subject_text = subject_text?.concat(result?.name)
          subject_text = subject_text.concat(',')
        }
      }
    }

    subject_text = subject_text.substring(0, subject_text.length - 1)
    return subject_text
  }

  const handleExport = async () => {
    const finalExportData: any[] = []
    const testTrackDetails: any = await getAllTestTrackDetails()

    if (testTrackDetails?.test_tracks?.length) {
      console.log(testTrackDetails?.test_tracks, 'test track details')
      // tableQueryResult?.data?.data?.map(record => {
      testTrackDetails?.test_tracks?.map((record: any) => {
        const id = record?.id
        const name = record?.name
        const gradeCount = record?.grade_ids?.length
        const subjectCount = record?.subject_ids?.length
        const loopCount = gradeCount > subjectCount ? gradeCount : subjectCount
        for (let i = 0; i < loopCount; i++) {
          let subject_id: string | undefined = ''
          let subject_name: string | undefined = ''
          let grade_id: string | undefined = ''
          let grade_name: string | undefined = ''
          if (record?.subject_ids?.[i] !== undefined) {
            const selectedSubject = subjectLists?.data?.data?.filter(eachSubject => eachSubject?.id === record?.subject_ids?.[i])[0]
            subject_id = selectedSubject?.id
            subject_name = selectedSubject?.name
          }
          if (record?.grade_ids?.[i] !== undefined) {
            const selectedGrade = gradeList?.data?.data?.filter(grade => grade?.id === record?.grade_ids?.[i])[0]
            grade_id = selectedGrade?.id
            grade_name = `${selectedGrade?.name}`
          }
          finalExportData.push({ id, name, subject_id, subject_name, grade_id, grade_name })
        }
      })
    }

    exportToExcel(finalExportData, `test_tracks_${Math.round(new Date().getTime() / 1000)}.xlsx`)
    setExportButtonLoading(false)
  }

  const hideDeleteButton = (record: ITestTrack): boolean => {
    let matchFound = false
    let allTestTrackList: (string | BaseKey)[] = []
    if (productQueryResult?.data?.data !== undefined) {
      productQueryResult.data.data.forEach(product => {
        allTestTrackList.push(...product.test_track_ids)
      })
      for (let trackId of allTestTrackList) {
        if (trackId === record.id) {
          matchFound = true
          break
        }
      }
    }
    if (!matchFound) {
      return record?.created_by === user?.id
    }
    return matchFound
  }

  const renderGrades = (item: any) => {
    let text: object[] = []
    for (let i = 0; i < item?.length; i++) {
      let result = gradeList?.data?.data?.filter((grade: any) => item[i] === grade?.id)[0]
      if (result !== undefined) {
        text.push(<Tag>{result?.name}</Tag>)
      }
    }
    return text
  }

  // const onChange = (page: number, pageSize?: any): void => {
  //   setCurrent(page)
  // }

  // const searchByName = (value: any) => {
  //   setHasPagination(false)
  //   setTestTrackFilters([
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `%${value}%`,
  //     },
  //   ])
  // }

  // useEffect(() => {
  //   if (userRole === 'productmanager') {
  //     setTestTrackFilters([{ field: 'created_by', operator: 'eq', value: user?.id }])
  //   }
  // }, [userRole])

  return (
    <>
      <List
        pageHeaderProps={{
          extra: [
            // <ExportButton
            //   onClick={() => {
            //     console.log('Export button clicked')
            //     triggerExport()
            //   }}
            //   loading={isLoading}
            // />,

            <Button
              icon={<ExportOutlined />}
              loading={exportButtonLoading}
              onClick={() => {
                setExportButtonLoading(true)
                handleExport()
              }}
            >
              Export
            </Button>,
            <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
            <CreateButton
              type="primary"
              style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
              icon={<PlusOutlined />}
              onClick={() => show()}
            />,
          ],
        }}
      >
        <Divider />
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <div
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                padding: '1rem',
                height: '4rem',
                borderRadius: '10px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <h4>
                Active Test Tracks : <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{testTrackCount}</span>
              </h4>
            </div>
          </Col>
        </Row>
        <Divider />
        {/* <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      /> */}
        <Form {...searchFormProps}>
          <Space>
            <Form.Item name="name">
              <Input placeholder="Search by Name" />
            </Form.Item>
            <Button type="primary" icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
              Search
            </Button>
            <Button
              onClick={() => {
                searchFormProps?.form?.setFieldsValue({ name: '' })
                searchFormProps.form?.submit()
              }}
            >
              Clear
            </Button>
          </Space>
        </Form>
        <Divider />
        {readPermission !== undefined && readPermission.granted ? (
          <Table
            {...tableProps}
            rowKey="id"
            size="small"
            onRow={record => ({
              style: {
                opacity: record.in_use ? 1 : 0.3,
                transition: 'opacity 0.3s ease',
              },
            })}
          >
            <Table.Column dataIndex="name" title="Name" />

            <Table.Column<ITestTrack> dataIndex="grade_id" render={(_, record) => renderGrades(record?.grade_ids)} title="Grades" />
            {/* <Table.Column<ITestTrack> dataIndex="subject_ids" render={(_, record) => renderSubjects(record)} title="Subjects" /> */}
            <Table.Column<ITestTrack> dataIndex="subject_ids" render={(_, record) => renderItems(record?.subject_ids, 'subject')} title="Subjects" />
            <Table.Column<ITestTrack>
              dataIndex="report_theme_ids"
              render={(_, record) => renderItems(record?.report_theme_ids, 'reportTheme')}
              title="Report Themes"
            />
            <Table.Column
              dataIndex="created_at"
              title="Created At"
              render={value => <DateField value={value} format="LLL" />}
              defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
              sorter
            />
            <Table.Column<ITestTrack>
              title="Actions"
              className={editPermission !== undefined && editPermission?.granted ? 'show' : 'hide'}
              dataIndex="actions"
              render={(_, record) => (
                <Space>
                  <Popconfirm
                    title={record?.in_use ? 'Are you sure you want to disable this Test Track?' : 'Are you sure you want to enable this Test Track?'}
                    onConfirm={async () => {
                      await updateVisibiltityStatus([record.id], !record.in_use, `test_tracks`, `id`, `in_use`)
                      await tableQueryResult?.refetch()
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      icon={record?.in_use ? <Icons.EyeOutlined /> : <Icons.EyeInvisibleOutlined />}
                      size="small"
                      style={{
                        color: record?.in_use ? '#80bde0' : '#fa7070',
                      }}
                    />
                  </Popconfirm>

                  {editPermission !== undefined && editPermission?.granted && record?.in_use ? (
                    <EditButton
                      size="small"
                      type="link"
                      icon={<Icons.EditOutlined />}
                      recordItemId={record.id}
                      onClick={() => editShow(record.id)}
                      hidden={hideDeleteButton(record) || (userRole !== 'admin' && userRole !== 'productmanager')}
                      hideText
                    />
                  ) : null}
                  {deletePermission !== undefined && deletePermission?.granted && record?.in_use ? (
                    <DeleteButton
                      size="small"
                      type="link"
                      icon={<Icons.DeleteOutlined />}
                      recordItemId={record.id}
                      hidden={hideDeleteButton(record)}
                      onSuccess={() => setTestTrackCount(testTrackCount - 1)}
                      hideText
                    />
                  ) : null}
                </Space>
              )}
            />
          </Table>
        ) : null}
        <CreateTestTrack modalProps={modalProps} formProps={formProps} />
        <EditTestTrack modalProps={editModalProps} formProps={editFormProps} />
      </List>
    </>
  )
}
